import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UsersService } from '../../../../services/users/user.service';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { OverlayModule } from '@angular/cdk/overlay';
import { VoiceMacro } from '@allaihealth/util';
import { VoiceMacroData, VoiceMacroDialog } from '../../../../components/voice-macro-new-dialog/voice-macro-dialog.component';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ImportVoiceMacroDialog } from '../../../../components/voice-macro-new-dialog/import-voice-macro-dialog.component';
import { YesNoDialogComponent } from '../../../../components/yes-no-dialog/yes-no-dialog.component';
import { PageLoaderService } from '../../../../services/page-loader.service';
import { SnackbarService } from '../../../../services/snackbar.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
/** The user metric page */
@Component({
	selector: 'app-user-macros',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule,
		MatTableModule,
		OverlayModule,
		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		MatPaginatorModule,
		MatTooltipModule
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './user-macros.component.html',
	styleUrl: './user-macros.component.scss'
})
export class UserVoiceMacroComponent implements OnInit, OnDestroy {

	voiceMacroDataSource: MatTableDataSource<VoiceMacro>;

	readonly displayedColumns: string[] = ['actions', 'id', 'section', 'phrase', 'substitution'];

	globalSearch: FormControl<string>;

	/** Is the field disabled? */
	private _disabled:boolean = false;

	/** tooltip for New/Import buttons */
	public tooltipText: string;

	@ViewChild(MatPaginator)
	paginator: MatPaginator;

	constructor(private usersService: UsersService,
		private dialog: MatDialog,
		private pageLoaderService: PageLoaderService,
		private snackBarService: SnackbarService) {
	}

	ngOnInit() {
		this.globalSearch = new FormControl<string>('');
		this.usersService.onNewUserDetail.subscribe(() => {
			this.refresh();
		});
	}

	ngAfterViewInit(): void {
	}

	private refresh() {
		this.voiceMacroDataSource = new MatTableDataSource<VoiceMacro>(this.usersService.userDetail.voiceMacros);
		this.voiceMacroDataSource.paginator = this.paginator;
		this.checkMacroLimit();
	}

	ngOnDestroy() {
	}

	async newMacro() {
		const response = await this.openVoiceMacroDialog({
			section: null,
			phrase: null,
			substitution: null
		});

		if (response) {
			this.pageLoaderService.show("Saving new macro");
			try {
				await this.usersService.newMacro(response);
				this.refresh();
			}
			catch (err) {
				this.snackBarService.error("Error saving new voice macro.");
			}
			this.pageLoaderService.close();
		}

	}

	async importMacros() {
		const response = await this.openImportDialog();

		if (response) {
			this.pageLoaderService.show("Importing macros");
			try {
				await this.usersService.importMacros(response);
				this.refresh();
			}
			catch (err) {
				this.snackBarService.error("Error importing voice macros.");
			}
			this.pageLoaderService.close();

		}
	}

	private openVoiceMacroDialog(data: VoiceMacroData): Promise<VoiceMacroData> {
		const ref = this.dialog.open(VoiceMacroDialog, { data });
		return firstValueFrom<VoiceMacroData>(ref.afterClosed());
	}

	private openImportDialog(): Promise<VoiceMacroData[]> {
		const ref = this.dialog.open(ImportVoiceMacroDialog);
		return firstValueFrom<VoiceMacroData[]>(ref.afterClosed());
	}

	async deleteItem(macro: VoiceMacro) {
		const ref = this.dialog.open(YesNoDialogComponent, {
			data: {
				title: "Delete Macro",
				message: `Really delete: ${macro.phrase}`
			}
		});
		const response = await firstValueFrom<any>(ref.afterClosed());
		if (response) {
			this.pageLoaderService.show("Deleting macro");
			try {
				await this.usersService.deleteMacro(macro);
				this.refresh();
			}
			catch (err) {
				this.snackBarService.error("Error deleting voice macro.");
			}
			this.pageLoaderService.close();

		}
	}

	async editItem(macro: VoiceMacro) {
		const response = await this.openVoiceMacroDialog({
			section: macro.section,
			phrase: macro.phrase,
			substitution: macro.substitution
		});

		if (response) {
			this.pageLoaderService.show("Updating macro");
			try {
				await this.usersService.updateMacro(macro, response);
				this.refresh();
			}
			catch (err) {
				this.snackBarService.error("Error updating voice macro.");
			}
			this.pageLoaderService.close();

		}

	}

	onEnterKey() {
		this.voiceMacroDataSource.filter = this.globalSearch.getRawValue();
	}

	async clickGlobalSearchX(event: MouseEvent) {
		if ((event as PointerEvent).pointerId > 0) {
			this.globalSearch.reset(null);
			this.voiceMacroDataSource.filter = '';
		}
	}

	onPageChange(event: PageEvent) {

    // Access the event properties:
    const newPageIndex = event.pageIndex;
    const newPageSize = event.pageSize;
    const previousPageIndex = event.previousPageIndex;
    const length = event.length;

    // Perform actions based on the new pagination state,
    // such as fetching data for the new page or updating your displayed items.
    // Example:
    // this.fetchData(newPageIndex, newPageSize);
  }

	checkMacroLimit() {

		console.info("this.voiceMacroDataSource", this.voiceMacroDataSource);
		console.info("this.voiceMacroDataSource.data.length", this.voiceMacroDataSource.data.length);
		console.info("this.usersService.userDetail.user.voice_macro_limit", this.usersService.userDetail.user.voice_macro_limit);

		// if the total number of macros is >= this user's limit, disable the New and Import buttons
		if (this.voiceMacroDataSource.data.length >= this.usersService.userDetail.user.voice_macro_limit) {
			this.setDisabledState(true);
			this.tooltipText = `Macro limit reached (${this.usersService.userDetail.user.voice_macro_limit})`;
		}	else {
			this.setDisabledState(false);
			this.tooltipText = null;
		}
	}

	setDisabledState?(isDisabled:boolean):void {
		this._disabled = isDisabled;
	}

	/** Is the field disabled? */
	get disabled():boolean {
		return this._disabled;
	}

}
